import { render, staticRenderFns } from "./TaskEditorDialog.vue?vue&type=template&id=0b15fe70"
import script from "./TaskEditorDialog.vue?vue&type=script&lang=js"
export * from "./TaskEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskEditorDialog.vue?vue&type=style&index=0&id=0b15fe70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports